import { InjectionToken } from '@angular/core';
import { BillingConfig } from './billing.interface';

export const BILLING_CONFIG = new InjectionToken<BillingConfig>(
  'BillingConfig',
);
